import { Drawer, List, ListItem, ListItemIcon, ListItemText, Divider, IconButton, Typography, Box } from '@mui/material';
import Logo from '../imagens/mely-logo-white.png';

import { AnalyticsOutlined, ArticleOutlined, BrowserUpdatedOutlined, CalculateOutlined, ContactSupportOutlined, DeliveryDiningOutlined, FormatPaintOutlined, GroupsOutlined, HistoryOutlined, HomeOutlined, InventoryOutlined, KeyboardDoubleArrowLeftRounded, LoginRounded, MenuOutlined, PointOfSaleOutlined, QrCodeOutlined, BugReportOutlined, RestaurantOutlined, RoomServiceOutlined, SettingsOutlined, TableBarOutlined, AccountBalanceWalletOutlined } from '@mui/icons-material';
import { SpacerMely } from './DesignSystem/SpacerMely';

export const CustomDrawer = ({ open, colorPrimary, toggleDrawer, currentPage, changePage, mesasNovos, deliveryNovos, retiradaNovos, plano, betaAtivo }) => {
    const menuItems = [
        { text: "Home", icon: <HomeOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "home", divider: true },
        { text: "Delivery", icon: <DeliveryDiningOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "entrega", title: "Funções PDV", novos: deliveryNovos },
        { text: "Mesa", icon: <TableBarOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "mesa", novos: mesasNovos },
        { text: "Retirada", icon: <RoomServiceOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "retirada", novos: retiradaNovos },
        { text: "Histórico", icon: <HistoryOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "historico" },
        { text: "Dashboard", icon: <AnalyticsOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "dashboard", divider: true },

        { text: "Fluxo de Caixa", icon: <CalculateOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "despesas", title: "Gestão Financeira" },
        { text: "Fechamento de Caixa", icon: <PointOfSaleOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "fechamento"},
        { text: "Minha Carteira", icon: <AccountBalanceWalletOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "carteira", divider: true  },

        { text: "Clientes", icon: <GroupsOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "clientes", title: "Funções Gerais" },
        { text: "Pedidos", icon: <ArticleOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "pedidos" },
        { text: "Cardápio", icon: <RestaurantOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "cardapio" },
        { text: "Estoque", icon: <InventoryOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "inventario" },
        { text: "QR Code", icon: <QrCodeOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "qrcode" },
        { text: "Personalizar", icon: <FormatPaintOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "personalizar" },
        { text: "Baixar PDV", icon: <BrowserUpdatedOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "pdv", divider: true },

        { text: "Configurações", icon: <SettingsOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "configuracoes", title: "Funções de Suporte" },
        { text: "Suporte", icon: <ContactSupportOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "suporte" },
        { text: "Reportar Erro", icon: <BugReportOutlined style={{ fontSize: open ? 24 : 20 }} />, path: "erro" },
        { text: "Sair", icon: <LoginRounded style={{ fontSize: open ? 24 : 20 }} />, path: "logout" }
    ];

    return (
        <Drawer
            variant="permanent"
            open={open}
            onClose={toggleDrawer(false)}
            sx={{
                width: open ? 315 : 72,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: open ? 315 : 72,
                    boxSizing: 'border-box',
                    transition: 'width 0.3s ease',
                    overflowX: 'hidden'
                },
            }}
        >
            <Box style={{
                display: "flex",
                alignItems: "center",
                padding: open ? "16px 16px 16px 20px" : "16px 8px",
                minHeight: 64,
                justifyContent: 'space-between'
            }}>
                {open ? (
                    <>
                        <Box style={{ display: "flex", alignItems: "center", color: "#999", fontSize: 12, fontWeight: "bold" }}>
                            <img alt="Logo Mely" src={Logo} style={{ width: 70, marginLeft: 'auto', marginRight: 'auto' }} />
                            {plano === "PROFISSIONAL" &&
                                <Box sx={{ background: "#dd4c1b", color: "#fff", p: "3px", borderRadius: 1, px: 1, ml: 1 }}>Profissional</Box>
                            }
                            {plano === "PADRÃO" &&
                                <Box sx={{ background: "#ffa50c", color: "#fff", p: "3px", borderRadius: 1, px: 1, ml: 1 }}>Padrão</Box>
                            }
                            {plano === "BÁSICO" &&
                                <Box sx={{ background: "#b48f7d", color: "#fff", p: "3px", borderRadius: 1, px: 1, ml: 1 }}>Básico</Box>
                            }
                            &nbsp;&nbsp;&nbsp;v2.3.2.2
                        </Box>

                        <IconButton onClick={toggleDrawer(false)} sx={{ marginLeft: 'auto' }}>
                            <KeyboardDoubleArrowLeftRounded />
                        </IconButton>
                    </>
                ) : (
                    <IconButton onClick={toggleDrawer(true)} sx={{ margin: 'auto' }}>
                        <MenuOutlined style={{ fontSize: 32 }} />
                    </IconButton>
                )}
            </Box>

            {/* {!open &&
                <Spacer space={40} />
            } */}
            <List sx={{ padding: open ? 2 : 1 }}>
                {menuItems.map((item) => (
                    ((item.path === "carteira" && betaAtivo) || item.path !== "carteira") &&
                    <Box key={item.text}>
                        {open && item.title &&
                            <Typography style={{ fontSize: 14, fontWeight: 600, textAlign: "center", color: "#fff", background: "#F94A3D", borderRadius: 10, marginBottom: 5 }}>
                                {item.title}
                            </Typography>
                        }
                        <ListItem
                            button
                            sx={{
                                cursor: "pointer",
                                borderRadius: 2,
                                mb: open ? 1 : .3,
                                justifyContent: open ? 'flex-start' : 'center',
                                backgroundColor: currentPage === item.path ? '#F2F2F2' : 'transparent',
                                height: 35,
                                px: open ? 3 : '12px'
                            }}
                            onClick={() => changePage(item.path)}
                        >
                            <ListItemIcon sx={{
                                minWidth: 'auto',
                                color: currentPage === item.path ? open ? '#464545' : "#F94A3D" : '#464545',
                                mr: open ? 2 : 0
                            }}>
                                {item.icon}
                            </ListItemIcon>

                            {open && (
                                <ListItemText
                                    primary={item.text}
                                    primaryTypographyProps={{
                                        color: currentPage === item.path ?
                                            (item.text === "Sair" ? "#F94A3D" : "#F94A3D") : "#464545",
                                        fontWeight: 700,
                                        fontSize: open ? 16 : 12
                                    }}
                                />
                            )}
                            {item.novos > 0 && open &&
                                <Typography style={{ background: "#F94A3D", color: "white", padding: "0px 10px 0px 10px", borderRadius: 4, maxHeight: 24 }}>{item.novos}</Typography>
                            }
                            {item.novos > 0 && !open &&
                                <Typography style={{ background: "#F94A3D", width: 10, height: 10, borderRadius: 10, marginLeft: 4, marginRight: -14 }}></Typography>
                            }
                        </ListItem>

                        {item.divider && (
                            <>
                                <SpacerMely height={5} />
                                <Divider />
                                <SpacerMely height={5} />
                            </>
                        )}
                    </Box>
                ))}
            </List>
        </Drawer>
    );
};